/// <reference path="../../../../../../typings/index.d.ts" />

module Meevo.Components.Controls {
    "use strict";

    export class SmartTilePropLocations implements angular.IComponentOptions {
        templateUrl = "app/components/controls/smartCenterDesigner/propertyViews/smartTilePropLocations.component.html";
        bindings: any = {
          tile: '=?',
          smartcenterBusinessTypeId: '=?',
          selectionChanged: '&?',
          smartcenterIsAvailableCo: '=?'
        }
        controller = class SmartTilePropLocationsController {
            public tile: Meevo.Model.SmartCenterSmartTile;
            public smartcenterBusinessTypeId: Guid;
            public smartcenterIsAvailableCo: boolean;
            static $inject = [
                "meevo.components.common.IdentityService",
                "meevo.components.common.DataService"
            ];

            public selectionChanged: Function;
            public newAddLocationDetail: Model.LocationListItem
            public newAddSmartCenterLocation: Model.LocationListItem;
            public newAddLocationGroupDetail: Model.LocationGroupListItem;
            public parameter: any;
            public actingLocationId: number = this.identityService.locationId;
            public selectedLocationFilter = false;
            public showLocationFilter = false;
            public locationGroup: any;           
            /**
            * Multi-location type and filter
            */
            public locationFilterType = [
                { name: 'Location', value: false },
                { name: 'Location Group', value: true }
            ];

            constructor(protected identityService: Meevo.Components.Common.IIdentityService,
                protected dataService: Components.BaseClasses.IDataService) { }

            $onInit(): void {
                // Today's Wait List
                if (this.tile.id === 39) {
                    this.locationFilterType = [{ name: 'Location', value: false }];
                }

                if (Model.Guard.isNothing(this.newAddSmartCenterLocation)) {
                    this.newAddSmartCenterLocation = { id: this.identityService.locationId, address1: '', address2: '', city: '', state: '', zipCode: '', storeName: '', storeNumber: '' };
                }
                if (Model.Guard.isNothing(this.newAddLocationGroupDetail)) {
                    this.newAddLocationGroupDetail = { businessTypeId: '', displayName: '', id: '' };
                }
                if (Model.Guard.isNothing(this.parameter)) {
                    this.parameter = {
                        locations: null,
                        employeeId: '',
                        homeLocationId: -1,
                        asLocationId: this.identityService.locationId,
                        isSharedEmployee: null,
                        isMultiLocationEmployee: null
                    };
                }

                //if there is LocationGroup in Parameters Json metadata, show Filter By Location when you edit smart center tiles 
                if (this.tile && this.tile.parsedParameters["locationGroup"])
                    this.showLocationFilter = true; 

                if (this.tile && this.tile.parsedParameters["locationGroup"] && this.tile.parsedParameters["locationGroup"].parameterValue) {
                    this.selectedLocationFilter = true;                    
                    var _locationGroupID = this.tile.parsedParameters["locationGroup"].parameterValue;
                    var baseEndpoint = '/api/LocationGroup/' + _locationGroupID;
                    this.dataService.customMethodData(baseEndpoint, 'GET', null).then(response => {
                        this.newAddLocationGroupDetail =  {
                            displayName : response.data.displayName, id :_locationGroupID
                        };                        
                    });
                }
                if (this.tile && this.tile.parsedParameters["locations"].parameterValue) {
                    var _locationID = this.tile.parsedParameters["locations"].parameterValue;
                    if (Model.Guard.isSomething(_locationID)) {
                        var baseEndpoint = '/api/Location/maintenance/' + _locationID;
                        this.dataService.customMethodData(baseEndpoint, 'GET', null).then(response => {
                            this.newAddLocationDetail = {
                                storeName: response.data.storeName, id: _locationGroupID
                            };
                        });
                    }                       
                }
            }
            public locationCriteria = {
              businessTypeId: this.smartcenterBusinessTypeId
            };
            public locationGroupCriteria = {
              businessTypeId: this.identityService.current().tenantData.allBusinessTypeId === String(this.smartcenterBusinessTypeId) ? null : this.smartcenterBusinessTypeId,
              IncludeAllLocationsListItem: true
            }

            verifyModel(): boolean {
                return Model.Guard.isSomething(this.parameter.locations);
            };
            disableSecurityField = function (asLocationId) {
                return (!(this.mode === Meevo.Model.MaintenanceFormState.Readonly) && this.canEditSecurity(asLocationId));
            };
            selectCurrentLocation(id: number) {

            }
            public isApplicationModeCO(): boolean {
                return this.identityService.inCentralOfficeMode();
            }
            onSelectionChanged(): void {
                if (!this.selectedLocationFilter) {
                    this.tile.isForLocationGroup = false;
                if (Model.Guard.isNothing(this.newAddSmartCenterLocation) || this.verifyModel() === false)
                  return;
                this.selectedLocationFilter = false;
                if (Model.Guard.isSomething(this.newAddLocationDetail)) {
                  this.tile.parsedParameters["locations"].parameterDisplayName = this.newAddLocationDetail.storeName;
                  this.tile.parsedParameters["locations"].parameterValue = this.newAddLocationDetail.id;
                }
                this.tile.parsedParameters["locationGroup"].parameterValue = "";
              }
                else {
                    this.tile.isForLocationGroup = true;
                //this.getLocationIdsForLocationGroup(this.newAddLocationGroupDetail.id);
                if (Model.Guard.isSomething(this.newAddLocationGroupDetail)) {
                  this.tile.parsedParameters["locationGroup"].parameterValue = this.newAddLocationGroupDetail.id;
                  this.tile.parsedParameters["locationGroup"].parameterDisplayName = this.newAddLocationGroupDetail.displayName;
                }
                this.tile.parsedParameters["locations"].parameterValue = null;
              }
            }
        }
    }
  angular.module("meevo.components.controls")
    .component("stpLocations", new SmartTilePropLocations());
}
